// @flow
import { Record, List } from 'immutable';
import Question from './Question';
import EmptyList from './EmptyList';

const WDYBRecord = Record({
  ugc_id: '',
  subject_id: null,
  ugctype: 'WDYB',
  ugc_archetype: '',
  created_date: '',
  updated_date: '',
  published: null,
  author: '',
  location: '',
  answer: '',
  email: '',
  answerer_type: '',
  source: '',
  ip_address: '',
  device_id: '',
  locale: '',
  ugc_related_content: EmptyList,
});

export default class WhyDidYouBuy extends WDYBRecord {
  static createWithData(data: { [string]: any }) {
    return new WhyDidYouBuy({
      ...data,
      ugc_related_content: List([
        new Question({
          created_date: data.created_date,
          question: 'Why Did You Buy?',
        }),
      ]),
    });
  }

  getQuestion() {
    return this.ugc_related_content.find(ugc => ugc.ugctype === 'Question');
  }
}



// WEBPACK FOOTER //
// ./src/models/WhyDidYouBuy.js